import { render, staticRenderFns } from "./CookingCheckMenu.vue?vue&type=template&id=31ae5720&"
import script from "./CookingCheckMenu.vue?vue&type=script&lang=js&"
export * from "./CookingCheckMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports